import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $PreferredStoreModuleName } from "./preferredStore.types";

const { isLoading, error } = generateDefaultSelectors(
    $PreferredStoreModuleName,
);

const getPreferredStore = (state: IState) =>
    getApiDataState(state, $PreferredStoreModuleName)?.data;

const hasError = (state: IState) =>
    !!getApiDataState(state, $PreferredStoreModuleName)?.error;

export { isLoading, error, hasError, getPreferredStore };
